import { httpCreate } from './http';

const http = httpCreate('/srv/wheel-activity');

export const wheelActivity = {
	/**
	 * PC端获取活动列表
	 * @param {Number} activityId 【直播间ID】
	 * @param {Object} params
	 *  pageNum(当前页数)
	 *  pageSize(每页条数)
	 *  status(动状态：0-未开始 1-进行中 2-已结束)
	 * @return {*}
	 */
	getTurntableList(activityId, params) {
		console.log(activityId);
		return http.get(`/list/pc/${activityId}`, { params });
	},
	/**
	 * 创建转盘
	 *
	 * @param {Number} activityId 【直播间ID】
	 * @param {Object} data
	 *   title(活动标题，12个字符)
	 *   rule(规则，250个字符)
	 *   type(抽奖类型【0：移动端 1：大屏】)
	 *   winPercent(中奖概率)
	 *   totalAmount(付费总金额，奖品中有红包时必填，用于校验)
	 *   startTime(活动开始时间，直播间抽奖时必填)
	 *   endTime(活动结束时间，直播间抽奖时必填)
	 *   limitType(抽奖限制类型 【0：总共最多，1：每日最多】，直播间抽奖时必填)
	 *   maxCount(最大抽奖参与次数，直播间抽奖时必填)
	 *   maxCount(最大中奖次数，直播间抽奖时必填)
	 *   claimArea(可领取区域)
	 *   @params {Array} prizeList(奖品列表)
	 *     prizeId(奖品id，红包奖品为0)
	 *     num(奖品数量)
	 *     allowFlag(是否允许抽中 【0：不允许 1：允许】)
	 *     type(奖品类型 0：红包 1：卡券 2：实物)
	 *     amountSingle(单个红包金额)
	 * @return {*}
	 */
	createTurntable(activityId, smsCode, data) {
		return http.post(`/${activityId}`, data, { params: { smsCode } });
		// return http.post(`/${activityId}`, data);
	},
	/**
	 * 修改转盘
	 *
	 * @param {Number} wheelActivityId 【转盘ID】
	 * @param {Object} data 【同创建转盘】
	 * @return {*}
	 */
	editTurntable(wheelActivityId, smsCode, data) {
		// return http.put(`/${wheelActivityId}?smsCode=${smsCode}`, data);
		return http.put(`/${wheelActivityId}`, data);
	},
	/**
	 * 获取转盘信息
	 *
	 * @param {Number} wheelActivityId
	 * @return {*}
	 */
	getTurntableInfo(wheelActivityId) {
		return http.get(`/${wheelActivityId}`);
	},
	/**
	 * 结束转盘
	 *
	 * @param {Number} wheelActivityId
	 * @return {*}
	 */
	endTurntable(wheelActivityId) {
		return http.put(`/end/${wheelActivityId}`);
	},
	/**
	 * 删除转盘
	 *
	 * @param {Number} wheelActivityId
	 * @return {*}
	 */
	deleTurntable(wheelActivityId) {
		return http.delete(`/${wheelActivityId}`);
	},
	/**
	 * 获取奖品发放情况
	 *
	 * @param {Number} wheelActivityId
	 * @return {*}
	 */
	getPrizeGrantInfo(wheelActivityId) {
		return http.get(`/prizeUseInfo/${wheelActivityId}`);
	},
	/**
	 * 获取参与列表（活动数据）
	 *
	 * @param {*} activityId
	 * @param {*} params
	 * @return {*}
	 */
	getJoinList(activityId, params) {
		return http.get(`/user/list/${activityId}`, { params });
	},
	/**
	 * 获取所有活动列表
	 *
	 * @param {Number} activityId 【直播间ID】
	 * @param {Number} status 【状态（0：未开始 1：进行中 2：已结束）】
	 * @return {*}
	 */
	getAllActivityList(activityId, status = '') {
		return http.get(`/all/${activityId}?status=${status}`);
	},
	/**
	 * 核销
	 *
	 * @param {Number} id 【核销ID】
	 */
	verdict(id, formData) {
		return http.put(`/user/verdict/${id}`, formData);
	},

	// 是否客户定制
	isCustom(activityId) {
		return http.get(`/isCustomer/${activityId}`);
	},
	manualOpenLottery(id) {
		return http.put(`/start/${id}`);
	},
};
